export default "__VITE_ASSET__CWkQHDAQ__"